import * as React from 'react';
import * as DotStyles from './DotDotDotField.scss';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { DeferredRender } from '../../../utilities/components/DeferredRender';

export interface IDotDotDotFieldProps {
  onClick: (ev: React.MouseEvent<HTMLButtonElement>) => void;
  isDisabled?: boolean;
  /** aria label of the field. */
  ariaLabel?: string;
  title?: string;
  pageLoadBarrier?: Promise<void>;
}

export interface IDotDotDotFieldState {
  isExpanded: boolean;
}

const ICON_PROPS = { iconName: 'MoreVertical' };

export class DotDotDotField extends React.PureComponent<IDotDotDotFieldProps, IDotDotDotFieldState> {
  constructor(props: IDotDotDotFieldProps) {
    super(props);
  }

  public render(): JSX.Element | null {
    let { ariaLabel, title } = this.props;

    return (
      <DeferredRender barrier={ this.props.pageLoadBarrier }>
        <IconButton
          className={ `${DotStyles.heroButton}` }
          onClick={ this._onClickDot }
          aria-label={ ariaLabel }
          aria-expanded={ false }
          aria-haspopup='true'
          data-automationid='FieldRender-DotDotDot'
          data-iscontextmenuhost='true'
          iconProps={ ICON_PROPS }
          title={ title }
        />
      </DeferredRender>
    );
  }

  private _onClickDot = (ev: React.MouseEvent<HTMLButtonElement>) => {
    this.props.onClick(ev);
    // Manually setting attributes on React-rendered elements is expressly a safe mutation.
    // It will be overridden if the component rerenders, but the menu will also be dismissed.
    ev.currentTarget.setAttribute('aria-expanded', 'true');
  }
}
